<template>
  <v-container text-xs-center>
    <v-layout row wrap>
      <v-container style="max-height: 75vh" class="scrollDesign">
        <v-layout row wrap style="margin-left: calc(100% - 612px)">
          <v-flex
            ma-1
            xs12
            class="expandableContainer"
            style="max-width: 612px"
          >
            <v-data-table
              v-model="selected"
              :headers="headers"
              :items="extras"
              :loading="loading"
              hide-actions
              ref="table"
              item-key="id"
              select-all
              no-data-text="No tiene extracurriculares"
              style="max-height: 18vh; overflow-y: scroll"
            >
              <template v-slot:headers="props">
                <tr>
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :style="`${
                      header.value === 'level' || header.value === 'group'
                        ? 'width: 200px; max-width: 200px; min-width: 200px;'
                        : 'width: 100px; max-width: 100px; min-width: 100px;'
                    }`"
                  >
                    <span>{{ header.text }}</span>
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <td style="width: 100px; max-width: 100px; min-width: 100px">
                  <v-avatar :tile="tile" :size="avatarSize">
                    <v-icon>sports_soccer</v-icon>
                  </v-avatar>
                </td>
                <td style="width: 200px; max-width: 200px; min-width: 200px">
                  <CustomTooltipOverflowText>
                    {{ props.item.level.typeLevel }}
                  </CustomTooltipOverflowText>
                </td>
                <td style="width: 100px; max-width: 100px; min-width: 100px">
                  <CustomTooltipOverflowText>
                    {{ props.item.gg.grade }}
                  </CustomTooltipOverflowText>
                </td>
                <td style="width: 200px; max-width: 200px; min-width: 200px">
                  <CustomTooltipOverflowText>
                    {{ props.item.gg.group }}
                  </CustomTooltipOverflowText>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>

        <!--v-on:desition="desitionDelete"-->
        <loading v-model="working.wLoading" text="Trabajando"></loading>
        <success v-model="toast.success" text="Operación Exitosa"></success>
        <error v-model="toast.failed" text="Ups ocurrió un error"></error>
      </v-container>
    </v-layout>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import confirm from '../../Dialogs/Confirm'
import error from '../../Dialogs/Error'
import loading from '../../Dialogs/Loading'
import success from '../../Dialogs/Success'
import LinkParent from '../../Modals/LinkParentModal'
import TutorModal from '../../Modals/TutorModal'
import CustomTooltipOverflowText from '../../generic/custom_tooltip_overflow_text.vue'

export default {
  components: {
    confirm,
    TutorModal,
    LinkParent,
    loading,
    success,
    error,
    CustomTooltipOverflowText,
  },
  props: ['extras', 'studentName', 'studentId', 'permits'],
  data: () => ({
    headers: [
      {
        text: '',
        align: 'center',
        sortable: false,
        value: 'photo',
        langKey: '',
      },
      {
        text: 'Nivel',
        align: 'left',
        value: 'level',
        langKey: 'students.table_exta.level',
      },
      {
        text: 'Actividad/Grado',
        value: 'lastName',
        langKey: 'students.table_exta.activity_grade',
      },
      {
        text: 'Grupo',
        value: 'group',
        langKey: 'students.table_exta.group',
      },
    ],
    selected: [],
    select: {
      parent: null,
    },
    working: {
      wLoading: false,
    },
    loading: false,
    avatarSize: '30px',
    tile: false,
    modals: {
      title: '',
      parent: false,
      import: false,
      value: false,
      LinkV: false,
    },
    confirm: {
      value: false,
      title: '',
      description: '',
      show: false,
    },
    buttonFab: {
      fab: false,
      hidden: false,
    },
    avatarSize: '30px',
    tile: false,
    gotImages: 0,
    toast: {
      success: false,
      failed: false,
    },
    imgKey: 0,
  }),
  created() {},
  mounted() {
    this.setLang()
  },
  methods: {
    setLang() {
      for (let i = 0; i < this.headers.length; i++) {
        const el = this.headers[i]
        el.text = this.$t(el.langKey)
      }
    },
  },
  watch: {
    getLang() {
      this.setLang()
    },
  },
  computed: {
    ...mapGetters(['getLang']),
  },
}
</script>
<style scoped>
::v-deep .v-datatable.v-table > tbody {
  max-height: initial !important;
  min-height: initial !important;
}
</style>
<style>
.no-padding {
  padding-left: 10%;
}
.position-no {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: -1;
}

.expandableContainer {
  border-style: solid;
  border-color: #e6e6e6;
  border-radius: 15px;
  border-width: 2px;
}
</style>
<style scoped>
th,
td {
  width: 550px;
  max-width: 550px;
  min-width: 550px;
}
</style>
